import styled from 'styled-components';

export const SWrapper = styled.div`
  width: 100%;
  max-width: 370px;
  min-width: 300px;
`;

export const SLabel = styled.label`
  font-size: 12.5px;
  font-weight: 500;
  letter-spacing: 0.21px;
  font-family: ${({ theme }) => theme.fonts.medium};
  color: ${({ theme }) => theme.colors.tertiaryText};
`;

interface IInputProps {
  isError: boolean;
}

export const SInput = styled.input<IInputProps>`
  height: 50px;

  border-radius: 5px;

  &:focus {
    outline: none;
    border: 2px solid ${({ theme }) => theme.colors.primaryText};
    ${({ isError, theme }) =>
      isError &&
      `
    border: 2px solid ${theme.colors.error}`}
  }

  ${({ isError, theme }) =>
    isError &&
    `
    border: 1px solid ${theme.colors.error}`}
`;

export const SIcon = styled.i`
  right: 15px;
  top: 14px;
  position: absolute;

  cursor: pointer;
  color: ${({ theme }) => theme.colors.primaryText};
`;

export const SErrorLabel = styled.label`
  width: 100%;
  text-align: right;

  font-size: 12.5px;
  letter-spacing: 0.18px;
  color: ${({ theme }) => theme.colors.error};
`;
